<template>
  <div>
    <b-modal
      :hide-header="alreadyChosenTimes?false:true"
      :hide-footer="true"
      content-class="modal-blue"
      id="choose-take-photo-times-modal"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="alreadyChosenTimes?false:true"
      size="lg"
    >
      <div class="row text-white justify-content-center">
        <div class="col-12"  v-if="!alreadyChosenTimes">
          
            <div v-if="this.$i18n.locale=='ka'">

                <p>Მოგესალმებით,&nbsp;</p>
<p>განცობებთ, რომ თქვენს მიერ MY UG გვერდზე ატვირთული ფოტო არ აკმაყოფილებს ბიომეტრიული მონაცემის იდენტიფიცირებისთვის დადგენილ სტანდარტს.</p>
<p>იმისათვის, რომ საგამოცდო აუდიტორიაში შეძლოთ შესვლა, აუცილებელია არსებული ფოტოს ცვლილება 23 დეკემბრის ჩათვლით. ახალი ფოტოს გადაღება მოხდება ფრონტ ოფისში, ამისათვის გთხოვთ, აირჩიოთ კალენდარში ფრონტ ოფისში &nbsp;ვიზიტის დრო /ადგილი და მობრძანდეთ თქვენს მიერ არჩეული თარიღის მიხედვით.</p>
<p><br></p>
<p>ფრონტ ოფისში ვიზიტამდე, გთხოვთ გადმოტვირთეთ უნივერსიტეტის ტერიტორიაზე დაშვებისთვის საჭირო SIGUR-ის აპლიკაცია (აქტივაცია მოხდება ვიზიტის დროს):</p>
<p><br></p>
<p>Ios: <a data-fr-linked="true" href="https://shorturl.at/Dg5QH">https://shorturl.at/Dg5QH</a></p>
<p>Android: <a data-fr-linked="true" href="https://shorturl.at/BJkGv">https://shorturl.at/BJkGv</a></p>
<p><br></p>

            </div>
            <div v-else>
                <p>Dear students,&nbsp;</p>
<p>We would like to inform you that the photo you uploaded to the MY UG page does not meet the standard required for biometric identification.</p>
<p>In order to be able to enter the examination room, it is necessary to change the existing photo no later than 23 December (inclusive). The new photo will be taken at the Front Office. For this, please select the date, time, and location of your Front Office visit in the calendar and come on the date you have chosen.</p>
<p>Before visiting the Front Office, please download the SIGUR application, which is required for access to the university premises (it will be activated during your visit to the Front Office):</p>
<p>iOS: <a data-fr-linked="true" href="https://shorturl.at/Dg5QH">https://shorturl.at/Dg5QH</a></p>
<p>Android: <a data-fr-linked="true" href="https://shorturl.at/BJkGv">https://shorturl.at/BJkGv</a></p>
<p><br></p>

            </div>

 
        </div>
        <div class="col-6">
          <div class="picker" v-if="!alreadyChosenTimes">
            <h2 v-if="this.$i18n.locale=='ka'">აირჩიეთ ადგილმდებარეობა , დღე და დრო</h2>             
            <h2 v-else>Choose a Day , Time & Branch</h2>             

                <p class="text-center" v-if="this.$i18n.locale=='ka'">აირჩიეთ ადგილმდებარეობა</p>
                <p class="text-center" v-else>Choose Branch</p>
            <div class="row">
              <div class="col-12 col-md-6">

                 <button
               
               
                class="btn m-1"
                :class="'Building 4 (Kostava M. 77a)' === selectedBranch ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedBranch = 'Building 4 (Kostava M. 77a)'"
              >
               {{this.$i18n.locale=='ka'?'მე-4 კორპუსი (მ.კოსტავას 77ა)':'Building 4 (Kostava M. 77a)'}}
             
            </button>


              </div>
              <div class="col-12 col-md-6">
                  <button
               
               
                class="btn m-1"
                :class="'P. Kavtaradze street, 4 Lane, 21 a' === selectedBranch ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedBranch = 'P. Kavtaradze street, 4 Lane, 21 a'"
              >
                  {{this.$i18n.locale=='ka'?'პ. ქავთარაძის 4 , 21ა':'P. Kavtaradze street, 4 Lane, 21 a'}}
               
              </button>

              </div>
            </div>

              

            <!-- Calendar -->
            <label v-if="this.$i18n.locale=='ka'">აირჩიეთ თარიღი:</label>
            <label v-else>Select Date:</label>
                    <flat-pickr
            ref="datepicker"
            v-model="selectedDate"
            :config="dateConfig"
            class="form-control"
            placeholder="Pick a date"
          />

            <div v-if="selectedDate">
            <!-- Time slots as buttons -->
            <label class="mt-3" v-if="this.$i18n.locale=='ka'">აირჩიეთ დრო:</label>
            <label class="mt-3" v-else>Select Time:</label>
            <div v-if="availableSlots.length" class="d-flex flex-wrap">
              <button
                v-for="slot in availableSlots"
                :key="slot"
                class="btn m-1"
                :class="slot === selectedTime ? 'btn-primary' : 'btn-outline-light'"
                @click="selectedTime = slot"
              >
                {{ slot }}
              </button>
            </div>
        
            </div>

            <!-- Save button -->
            <div class="d-grid mt-5">
              <button class="btn btn-outline-danger" @click="saveChosenDateAndTime">
                {{ this.$i18n.locale=='ka'?'შენახვა':'Save' }}
                
              </button>
            </div>           
            
          </div>
          <div v-else>
            
            <p v-if="this.$i18n.locale=='ka'">თქვენ დაჯავშვნეთ ვიზიტი ფოტოს გადასაღებად: მისამართი {{ alreadyChosenTimes[0].selectedBranch }} , დღე/დრო: {{alreadyChosenTimes[0].date}} - {{ alreadyChosenTimes[0].start+' - '+alreadyChosenTimes[0].end }}.</p>
            <p v-else> Your scheduled visit time to the front office (Address: {{ alreadyChosenTimes[0].selectedBranch }})  to take a photo: {{alreadyChosenTimes[0].date}} - {{ alreadyChosenTimes[0].start+' - '+alreadyChosenTimes[0].end }}.  </p>  
            
            




            <button 
              class="btn btn-sm btn-danger ml-2"
              @click="removeChosenTime(alreadyChosenTimes[0].studentComeDateID)"
            >
            {{ this.$i18n.locale=='ka'?'წაშლა და ახალი სლოტის არჩევა':'Delete and Choose New Slot' }}
             
            </button>   
            
           

          </div>           
        </div>
       
      </div>
    </b-modal>
  </div>
</template>

<script>
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ScheduleResource from "../api/scheduleResource";
const scheduleResource=new ScheduleResource()
export default {
  components: { FlatPickr },

  mounted(){


        scheduleResource.alreadyChosenTimes(2).then(response=>{
            //
            if(response.data.length>0){
              this.alreadyChosenTimes=response.data
            }           
        })

      

  },

 

  data() {
    return {
      selectedDate: null,
      selectedTime: "",
      availableTimes: {},
      availableSlots: [],
      alreadyChosenTimes:null,
    
      selectedBranch:null
    };
  },
 


  computed: {

    dateConfig() {
  const dates = Object.keys(this.availableTimes);

 

  return {
    dateFormat: "Y-m-d",
    enable: dates,
    monthSelectorType: "static",
    minDate: dates.length ? dates[0] : null
  };
}





  },
  watch: {
    selectedDate(newVal) {
      if (!newVal) {
        this.availableSlots = [];
        this.selectedTime = "";
        return;
      }

      // If Flatpickr gave us a Date object, format it
      if (Object.prototype.toString.call(newVal) === "[object Date]") {
        const picked = this.formatDate(newVal);
        this.availableSlots = this.availableTimes[picked] || [];
        this.selectedDate = picked; // overwrite with string version
      } else {
        // Already a string YYYY-MM-DD
        this.availableSlots = this.availableTimes[newVal] || [];
      }

      this.selectedTime = "";
    },
     selectedBranch(val){
      
      if(val){

        this.selectedDate=null
        this.selectedTime=""
        
        scheduleResource.getAvailableDatesAndTimes(val,2).then(response=>{
            
            this.availableTimes=response.data

        })


      }
    }
  },
  methods: {
    formatDate(dateObj) {
      const y = dateObj.getFullYear();
      const m = String(dateObj.getMonth() + 1).padStart(2, "0");
      const d = String(dateObj.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    saveChosenDateAndTime() {
      if (this.selectedDate && this.selectedTime && this.selectedBranch) {
    

            scheduleResource.saveChosenDateAndTime(this.selectedDate , this.selectedTime,this.selectedBranch,2).then(response=>{
                    
                    if(response.data=='ok'){
                        location.reload()
                    }else {

                        alert(`Time is not available`);
                    }
            })
    
    } else {
        alert("Please select date , time and branch");
      }
    },

    removeChosenTime(id) {
      scheduleResource.removeChosenTime(id)
            .then(() => {
              window.location.reload()
            });
    },
    approveContract(id){
      scheduleResource.approveContract(id)
      .then(() => {
              window.location.reload()
            });
    }
    ,
    forceRefreshMonth() {
    if (this.$refs.datepicker && this.$refs.datepicker.fp) {
      this.$refs.datepicker.fp.redraw(); // ✅ forces month/year label to update
    }
  }



  }
};
</script>

<style scoped>
.picker {
  font-family: Arial, sans-serif;
  padding: 20px;
  max-width: 400px;
}
label {
  font-weight: bold;
  display: block;
  margin-top: 15px;
}
button {
  min-width: 120px;
}
.summary {
  margin-top: 15px;
  background: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}



.flatpickr-monthDropdown-months,
.flatpickr-current-month select {
  position: relative;
  z-index: 99900000009 !important;
  background: #fff;
  color: #000;
}



</style>
